/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_InvestorInputs */

const cs_clients_tab_investor = /** @type {(inputs: Clients_Tab_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor`)
};

const en_clients_tab_investor = /** @type {(inputs: Clients_Tab_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor`)
};

/**
* | output |
* | --- |
* | "Investor" |
*
* @param {Clients_Tab_InvestorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_investor = /** @type {((inputs?: Clients_Tab_InvestorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_InvestorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_investor(inputs)
	return cs_clients_tab_investor(inputs)
});